export type Redirect = {
  from: string;
  to: string;
  statusCode: number;
};

export type GetRedirectsResponse = Redirect[];

export type RedirectsStore = {
  [key: string]: Redirect;
};

export const normalizePathForRedirect = (path: string): string => {
  return path.replace(/^\//, '');
};

export const normalizeRedirects = (redirects: GetRedirectsResponse): RedirectsStore => {
  return redirects.reduce<RedirectsStore>((acc, redirect) => {
    acc[redirect.from] = redirect;
    return acc;
  }, {});
};

export const getRedirectForPath = (
  path: string,
  redirects: RedirectsStore
): Redirect | undefined => {
  return redirects[path];
};

export const applyRedirect = (url: string): void => {
  window.location.href = url;
};

export const checkAndApplyRedirect = (path: string, redirects: RedirectsStore): boolean => {
  const normalizedPath = normalizePathForRedirect(path);
  const redirect = getRedirectForPath(normalizedPath, redirects);

  if (redirect) {
    applyRedirect(redirect.to);
    return true;
  }

  return false;
};
